<template>
  <span>
    <b-modal v-model="modal.visible" title="Move item" centered hide-footer @hidden="hideModal">
      <span>Choose where to move this item</span>
      <b-form-group>
        <b-form-radio-group v-model="position">
          <b-form-radio :disabled="selected.appendToRow" value="before">Before</b-form-radio>
          <b-form-radio :disabled="selected.appendToRow" value="after">After</b-form-radio>
        </b-form-radio-group>
      </b-form-group>

      <h4> Items: </h4>
      <b-form-radio-group v-if="item" v-model="selected">
        <ul>
          <li v-for="row in items" :key="row.id">

            <template v-if="item.type === 'row'">
              <b-form-radio :disabled="row.id === item.id" :value="{id: row.id, appendToRow: false}">
                <strong>row</strong>
                <b-badge v-if="row.id === item.id" variant="primary">this item</b-badge>
                <b-badge v-if="row.children.length === 0" variant="secondary">empty</b-badge>
              </b-form-radio>
            </template>
            <template v-else>
              <strong>row</strong>
              <b-badge v-if="row.children.length === 0" variant="secondary">empty</b-badge>
            </template>

            <ul>
              <template v-if="row.children.length">
                <li v-for="rowChild in rowChildren(row)" :key="rowChild.id" style="margin-left:2rem;">
                  <template v-if="item.type === 'row'">
                    <span>{{ rowChild.type }}</span>
                    <b-badge v-if="rowChild.id === item.id" variant="primary">this item</b-badge>
                  </template>
                  <template v-else>
                    <b-form-radio :disabled="rowChild.id === item.id || item.type === 'row'" :value="{id: rowChild.id, appendToRow: false}">
                      <span>{{ rowChild.type }}</span>
                      <b-badge v-if="rowChild.id === item.id" variant="primary">this item</b-badge>
                    </b-form-radio>
                  </template>
                </li>
              </template>

              <template v-if="!row.children.length && item.type !== 'row'">
                <li style="margin-left:2rem;">
                  <b-form-radio :value="{id: row.id, appendToRow: true}">
                    <span>insert into row</span>
                  </b-form-radio>
                </li>
              </template>
            </ul>
          </li>
        </ul>
      </b-form-radio-group>

      <br/>

      <b-button
        :disabled="!selected.id"
        variant="outline-primary"
        block
        @click="moveItem">
        Move Item
      </b-button>

    </b-modal>
  </span>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      position: 'before',
      selected: {
        id: null,
        appendToRow: null
      }
    }
  },
  computed: {
    ...mapState('items', [
      'saving',
      'fetching'
    ]),
    ...mapGetters('items', {
      modal: 'moveModal'
    }),
    item () {
      return this.$store.getters['items/byID']({id: this.modal.id})
    }
  },
  methods: {
    hideModal(e) {
      this.$store.commit('items/hideMoveModal')
    },
    rowChildren (item) {
      return this.$store.getters['items/children']({id: item.id})
    },
    moveItem () {
      this.$store.commit('items/moveItem', {
        id: this.item.id,
        position: this.position,
        selectedID: this.selected.id,
        appendToRow: this.selected.appendToRow
      })
      this.$store.commit('items/hideMoveModal')
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  padding: 0 !important;
  margin: 0 !important;
  list-style: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/items/move.vue